import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef,  } from 'react';
import { Popover, Button, Select, message } from 'antd';
const { Option } = Select;
import { ajax, unparam } from 'utils/common';

const Reading = forwardRef((props, ref) => {
    const queryString = unparam(window.location.search);
    const disbledRef = useRef(null);
    const selectRef = useRef(null);
    const [defaultDate, setDefaultDate] = useState(3);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setDefaultDate(localStorage.analysisShareType ? parseInt(localStorage.analysisShareType) : 3);
    },[])

    useImperativeHandle(ref, () => (
        {
            closePopover: ()=> {
                setVisible(false);
            }
        }
    ), []);

    const getShareUrl = () => {
        if(disbledRef.current){
            return;
        }
        disbledRef.current = true;
        ajax({
            url: "/rept/createTimelySign",
            data: {
                ...queryString,
                hours: defaultDate * 24,
            }
        }).then(res => {
            let result = res.data || {};
            if(res.status != 200){
                message.info(res.message || '复制失败，请刷新重试！');
                return;
            }
            let url = `${location.origin}${location.pathname}?accountId=${result.accountId || queryString.accountId}&sign=${result.sign || ''}&timestamp=${result.timestamp || ''}&lang=zh_cn`;
            navigator.clipboard.writeText(url).then(() => {
                message.success("已复制")
                localStorage.analysisShareType = defaultDate;
                setVisible(false);
            }, () => {
                setVisible(false);
            });
            disbledRef.current = false;
        }).catch(err => {
            console.log(err, "====>err")
            message.info('复制失败，请刷新重试！');
            disbledRef.current = false;
        })
    };

    const onChange = (value) => {
        setDefaultDate(value);
    };

    const content = (
        <div className="analysis-share-content" ref={selectRef}>
            <p className="analysis-share-title">分享报告</p>
            <p className="analysis-share-tip">无需登录即可查看</p>
            <p className="analysis-share-label">链接有效期：</p>
            <Select
                showSearch
                style={{ width: 234 }}
                value={defaultDate}
                placeholder="请选择"
                optionFilterProp="children"
                onChange={onChange}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                suffixIcon={<i className="iconfont icon-sanjiao"></i>}
                getPopupContainer={triggerNode => triggerNode.parentNode}
            >
                <Option value={1}>1天</Option>
                <Option value={3}>3天</Option>
                <Option value={7}>7天</Option>
            </Select>
            <div className="analysis-share-btn" onClick={getShareUrl}>复制链接</div>
        </div>
    );

    return (
        <Popover
            className="analysis-share-prprver"
            placement="leftBottom"
            visible={visible}
            content={content}
            trigger="click"
            getPopupContainer={() => document.getElementById("analysis-share")}
        >
            <div className="analysis-share" id="analysis-share" onClick={() => {setVisible(!visible)}}>
                <i className="iconfont icon-fenxiang"></i>
                分享
            </div>
        </Popover>
    );
})

export default Reading;
